interface WelcomeScreenProps {
  onEnable: () => void;
  onSkip: () => void;
  onLoadDemo?: () => void;
}

export function WelcomeScreen({ onEnable, onSkip, onLoadDemo }: WelcomeScreenProps) {
  return (
    <div className="lock-screen">
      <div className="lock-card">
        <div className="lock-icon" aria-hidden="true">
          <LockGlyph />
        </div>
        <h1 className="lock-title">Protect your data</h1>
        <p className="lock-description">
          BioAvail stores pharmacokinetic study data in your browser. Enable a password
          to encrypt this data with AES-256-GCM so nobody can read it without your
          password.
        </p>
        <div className="lock-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onEnable}
          >
            Enable password protection
          </button>
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onSkip}
          >
            Skip for now
          </button>
          {onLoadDemo ? (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={onLoadDemo}
            >
              Skip — Load Demo
            </button>
          ) : null}
        </div>
        <p className="lock-hint">
          You can always enable or disable this later in Settings.
        </p>
      </div>
    </div>
  );
}

function LockGlyph() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}
